import { Action, Subject } from '@erp/authz';
import { SystemEntity } from '@erp/shared-types';
import { useCan } from 'src/hooks/useCan';

/** The task fields that decide whether a task can be deleted. */
export type DeletableTask = {
  deletedAt?: Date | string | null;
  anchorEntityType?: string | null;
};

/**
 * Whether the task itself can be deleted, ignoring the caller's permission.
 * A price-list case's task is deleted through the case (the service refuses
 * it here), so no surface offers a delete that can only fail.
 */
export function isTaskDeletable(task: DeletableTask): boolean {
  return (
    task.deletedAt == null &&
    task.anchorEntityType !== SystemEntity.IM_PRICELIST_CASE
  );
}

/** True when the caller may delete this task and the task can be deleted. */
export function useCanDeleteTask(task: DeletableTask): boolean {
  const [canDelete] = useCan(Action.Delete, Subject.Task);
  return canDelete && isTaskDeletable(task);
}
